import { useTranslation } from "react-i18next";
import { ScheduleRecentBill } from "src/api/contract/contract-types";
import Header from "src/components/layout/Header";
import { usePartnerNavigate } from "src/api/hooks/usePartnerNavigate";

type Props = {
  refundInfo: any;
  recentBill: ScheduleRecentBill;
  onClose: any;
  onClick: any;
};
const ContractCancel = ({ recentBill, onClose, onClick, refundInfo }: Props) => {
  const { t } = useTranslation(["contract", "common"]);
  // 확인 취소 버튼 있는 확인 모달
  console.log("ContractCancel refundInfo", refundInfo);
  return (
    <>
      <Header
        headerType="CLOSE"
        title={t("detail.cancelRequestHeader")}
        onClickCloseButton={() => {
          if (onClose!) {
            onClose();
          }
        }}
      />
      <div className="contract-page">
        <article className="with-backward-floating">
          {/* <RefundPolicy refundInfo={refundInfo} /> */}

          <section className={`base-section-layout`}>
            <div className="mt20 w-100">
              <p className="pre-formatted flex-center-center">{t("detail.cancelPolicyAgreement")}</p>
              <p className="pre-formatted flex-center-center">{t("detail.confirmCancelReservation")}</p>
            </div>
            <div className="base-floting-btn-wrap px0">
              <div className="cancel-modal">
                <div className="cancel-modal__contents">
                  <div className="cancel-modal__btn-wrap">
                    <button onClick={onClose} className="base-btn color-white mr10">
                      <p>{t("common:cancel")}</p>
                    </button>

                    <button onClick={() => onClick()} className="base-btn">
                      <p>{t("common:confirm")}</p>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </article>
      </div>
    </>
  );
};
export default ContractCancel;
